import React, { useEffect, useState } from "react";
import { Modal, ModalFooter, ModalHeader, ModalBody } from "reactstrap";
import Cookies from "js-cookie";
import SpinningWheel from "~/components/spinningWheel";
import WheelService from "~/services/spinningWheel";


const PointsWheelModal = () => {

  const [prize          , setPrize]          = useState(null);
  const [showPrize      , setShowPrize]      = useState(false);
  const [disabledButton , setDisabledButton] = useState(false);
  const [rewards        , setRewards]        = useState([]);
  const [isModalOpen    , setIsModalOpen]    = useState(false);

  useEffect(()=> {
    (async ()=> {
      setRewards(await WheelService.getPointsPrizes());
      const hasPointsClaim = await WheelService.hasSpinningWheelPoints();
      (!hasPointsClaim && Cookies.get("PushNotificaionQuestion")) && setIsModalOpen(true);
    })();
  },[]);

  const closeModal = ()=> setIsModalOpen(false);

  const handleSpinButton = async ()=> {
    setDisabledButton(true);
    setPrize(await WheelService.getPointsPrize());
  };

  return(
    <Modal isOpen={isModalOpen} toggle={closeModal} centered>

      <ModalHeader toggle={closeModal}> Points </ModalHeader>

      <ModalBody>
        <SpinningWheel rewards={rewards} prize={prize} onDone={()=> setShowPrize(true)} />
      </ModalBody>

      {!showPrize && <p className="text-center">
        Welcome to EarnDorado! <br/>
        Spin the wheel to earn your first points!
      </p> }
      { showPrize && <p className="text-center text-success"> <strong> Congratulation, you have won: {prize} Points! </strong> </p> }

      <ModalFooter className="jc-center">
        { !disabledButton &&<button className="btn btn-success pull-left" onClick={handleSpinButton} disabled={disabledButton}> Spin </button> }
        {  disabledButton && <button className="btn btn-danger pull-left" onClick={closeModal} disabled={!disabledButton}> Close </button> }
      </ModalFooter>

    </Modal>
  );

}

export default PointsWheelModal;
